import React from "react";
import Header from "../layouts/Employee/Header";
import SubHeader from "../layouts/Employee/SubHeader";
import LeavesListLayout from "../layouts/Employee/LeavesListLayout.jsx";

const LeavesList = () => {
  return (
    <>
      <Header />
      <SubHeader />
      <LeavesListLayout />
    </>
  );
};

export default LeavesList;
